import React from 'react';
import QuestionFAQ from './QuestionFAQ';
import './FAQ.css';

const FAQ = () => {
  return (
    <div className="faq-page">
      <section className="faq-hero">
        <h1>Foire aux Questions</h1>
        <p>Trouver des réponses à vos questions les plus fréquentes</p>
      </section>
      <section className="faq-content">
        <QuestionFAQ />
      </section>
    </div>
  );
};

export default FAQ;